<template>

    <div class="content-load" style="overflow-y: hidden; height: auto;">

        <img src="static/images/logo.png" style="width: 100%; height: 100px; object-fit: contain; margin: 30px auto;">

        <div v-if="detalhes">
            <table class="table table-bordered table-bordered-default">
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                Ordem de Serviço nº {{detalhes.id}}
                            </strong>
                        </td>
                        <td>
                            <strong>Data:</strong> {{detalhes.checkout | formatDate}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Cliente:</strong> {{detalhes.cliente.nome}}
                        </td>
                        <td>
                            <strong>Razão Social:</strong> {{detalhes.cliente.empresa ? detalhes.cliente.empresa : '-'}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" v-if="detalhes.cliente.cnpj">
                            <strong>CNPJ:</strong> {{detalhes.cliente.cnpj}}
                        </td>
                        <td colspan="2" v-if="detalhes.cliente.doc && !detalhes.cliente.cnpj">
                            <strong>CPF:</strong> {{detalhes.cliente.doc}}
                        </td>                        
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Endereço:</strong> {{detalhes.cliente.endereco}}, {{detalhes.cliente.numero != '' ? detalhes.cliente.numero : 's/n'}}. {{detalhes.cliente.cep}}. {{detalhes.cliente.bairro}}. {{detalhes.cliente.cidade}} - {{detalhes.cliente.estado}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Responsável: </strong>{{detalhes.equipe.nome}}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Checkin : </strong>{{detalhes.checkin | formatDate}}</td>
                        <td><strong>Checkout : </strong>{{detalhes.checkout | formatDate}}</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>E-mail:</strong>
                            {{detalhes.cliente.email}}
                        </td>
                        <td>
                            <strong>Telefone:</strong>
                            {{detalhes.cliente.telefone}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Descrição:</strong> <br><p style="margin-bottom: 0px; line-height: 130%; white-space: pre-wrap;">{{detalhes.observacoes}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Instruções:</strong> <br><p style="margin-bottom: 0px; line-height: 130%; white-space: pre-wrap;">{{detalhes.instrucoes}}</p>
                        </td>
                    </tr>
                    <tr v-if="detalhes.itens.length > 0">
                        <td colspan="2">
                            <strong>Itens da ordem de serviço:</strong><br/>
                                
                            <table class="table table-bordered table-bordered-default" style="margin-top: 15px;">
                                <thead>
                                    <th style="height: 20px; line-height: 10px;">Item</th>
                                    <th style="text-align: right; width: 130px; height: 20px; line-height: 10px;">Valor</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in detalhes.itens">
                                        <td>{{item.nome}}</td>
                                        <td style="text-align: right;">R$ {{item.valor | toMoney}}</td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: right;">
                                            <b>Total</b>
                                        </td>
                                        <td style="text-align: right;">
                                            <b>R$ {{detalhes.valor | toMoney}}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Fotos:</strong><br/>
                            <div class="details-photos" style="flex-wrap: wrap;">
                                <div v-for="(item, index) in detalhes.arquivos" class='detail-photo'>
                                    <div class='container-photo-os'>
                                        <img :src='item.link' v-on:load="loadImage"/>
                                    </div>
                                    <strong>Foto {{index+1}}</strong>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <strong>Comentários das Fotos:</strong><br /><br>
                            <ol>
                                <li v-for="(item, index) in detalhes.arquivos">
                                    <strong>{{item.descricao}}</strong>
                                </li>
                            </ol>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table style="width: 100%;">
            </table>
        </div>

    </div>
</template>

<script>
export default {
    name:                           'OS',
    components: {
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },          
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "images":               0,
            "loaded":               false,
            "detalhes":             null,
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
            },
        }
    },  
    methods: {   
        loadImage: function(e) {
            var self = this;
            console.log("loadImage()", e)

            self.images++;

            if (self.images == self.detalhes.arquivos.length) {
                window.print();            
            }

        }, 
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/visitas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.detalhes               = response.data.result;
                    self.detalhes.instrucoes    = self.detalhes.instrucoes.replaceAll('\\n','\n');
                    self.detalhes.observacoes   = self.detalhes.observacoes.replaceAll('\\n','\n');

                    self.loaded             = true;
                    self.$forceUpdate();
                    loading.hide();

                    if (self.detalhes.arquivos.length == 0) {
                        setTimeout(function() {
                            window.print();
                        }, 500);
                    }

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },        
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
    },
    activated: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        loading.show();
        self.form.cod = self.$route.query.c;
        self.get();        
    },    

}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/OS.vue